import { useBridge } from '../../../application/hooks/useBridge';
import { DefaultBox } from '../../etc/LBox/LBox';
import { useRecoilState } from 'recoil';
import * as Atom from '../../../application/recoil';
import { useTerms } from '../../../application/hooks/useTerms';

const TestLgu = () => {
  const br: any = useBridge();

  // let br:any;
  // useEffect(() => {
  //     br = Bridge('lgu');
  // },[])
  const [userInfo] = useRecoilState(Atom.userInfo);
  const [personal] = useRecoilState(Atom.personalInfo);

  const moveExternalWebBrowser2 = () => {
    console.log('openExternalBrowser');
    br?.openExternalBrowser({ url: '//naver.com' });
  };
  const moveExternalWebBrowser = () => {
    console.log('openExternalBrowser');
    br?.openExternalBrowser({ url: 'https://naver.com' });
  };
  const moveInternalWebBrowser = () => {
    console.log('openInternalBrowser');
    br?.openNativeWebView({
      url: 'https://naver.com',
      title: '대출 비교/테스트',
      closeType: 'B',
    });
  };
  const closeScreen = () => {
    console.log('close');
    br?.close();
  };
  const movePassMain = () => {
    console.log('goNativeMain');
    br?.goNativeMain();
  };
  const showErrorPage = () => {
    console.log('showErrorPage');
    br?.showErrorPage();
  };
  const showTermsScreen = () => {
    console.log('showTermsScreen');
    br?.showTerms();
  };
  const moveRequestAddService = (tabSeq: any) => {
    console.log('moveRequestAddService');

    br?.requestAddService({
      type: 'EBMP',
      url: `?tabSeq=${tabSeq}&track_cd_type=B007BA01`,
    });
  };
  const { showTerm }: any = useTerms();

  return (
    <DefaultBox>
      <h1>bridge interface LGU</h1>
      <p>srcCd : {userInfo.srcCd}</p>
      <p>custSeq : {personal.custSeq}</p>
      <p>env : {process.env.REACT_APP_ENV}</p>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
        query : <br />
        {window.location.search}
      </p>
      <br />
      <div>
        <button onClick={showTerm}>약관 동의 후 닫힘 테스트</button>
      </div>
      <div>
        <button onClick={moveExternalWebBrowser2}>
          // 외부 브라우저로 이동
        </button>
      </div>
      <div>
        <button onClick={moveExternalWebBrowser}>외부 브라우저로 이동</button>
      </div>
      <div>
        <button onClick={moveInternalWebBrowser}>내부 브라우저로 이동</button>
      </div>
      <div>
        <button onClick={closeScreen}>화면 종료</button>
      </div>
      <div>
        <button onClick={movePassMain}>PASS 메인화면 홈 탭으로 이동</button>
      </div>
      <div>
        <button onClick={showErrorPage}>오류 페이지</button>
      </div>
      <div>
        <button onClick={showTermsScreen}>약관 동의 화면 표시</button>
      </div>
      <div>
        <button onClick={() => moveRequestAddService(1)}>
          금융상품 대출탭 으로 이동
        </button>
      </div>
      <div>
        <button onClick={() => moveRequestAddService(2)}>
          금융상품 카드탭 으로 이동
        </button>
      </div>
      <div>
        <button onClick={() => moveRequestAddService(3)}>
          금융상품 보험탭 으로 이동
        </button>
      </div>
      <div>
        <button onClick={() => moveRequestAddService(4)}>
          금융상품 재테크탭 으로 이동
        </button>
      </div>
      <div>
        <button onClick={() => moveRequestAddService(5)}>
          금융상품 모아보기탭 으로 이동
        </button>
      </div>
    </DefaultBox>
  );
};

export default TestLgu;
